export const Tag = ({ tag }) => {
  return (
    <p className="mb-1 mx-1 p-1 inline-block capitalize border border-[#ff8675]">
      {tag}
    </p>
  );
};
